export const DEFAULT_ERROR_MESSAGE =
  "Une erreur est survenue, veuillez reéssayer plus tard ou contacter le service client.";

export const FIELD_OBLIGATOIRE = "Ce champ est obligatoire";
export const EMAIL_INVALIDE = "Format invalide: mail@example.com";
export const TELEPHONE_INVALIDE = "Numéro de téléphone incorrect";
export const MESSAGING_MODE = "messagingMode";
export const PUBLIC_MODE = "publicMode";
export const ERROR_MODE = "errorMode";

export const PORTAIL_GU = "PGU"
